import { ReportConfigModel } from 'core/models/ReportConfigModel';
import { UserModel } from 'core/models/UserModel';
import { getToken, parseValue } from 'utils/helper';
import { logger } from 'utils/logger';

const reportHeaders = () => ({
    'Content-Type': 'application/json',
    hgio: getToken(),
});

const mapReportConfig = (item) => {
    const parsed = item?.rcPart || item?.rcSort ? item : parseValue(item);
    const model = new ReportConfigModel(parsed);
    return {
        ...model,
        recipients: model.recipients,
    };
};

const mapReportUser = (item) => {
    return new UserModel({ ...item, name: `${item.first} ${item.last}` });
};

const parseReportConfigResponse = (data, fallback) => {
    if (data?.item) {
        return mapReportConfig(data.item);
    }
    if (data?.rcPart || data?.rcSort) {
        return mapReportConfig(data);
    }
    return mapReportConfig(fallback);
};

export const getReportUsers = async () => {
    const url = `${process.env.REACT_APP_API_URL}/users/reports`;
    logger.log('GETTING Report Users: ', url);

    return fetch(url, {
        headers: reportHeaders(),
        method: 'GET',
    })
        .then((response) => response.json())
        .then((data) => {
            logger.log(data);
            if (!data?.users?.length) return [];
            const users = data.users.map(mapReportUser);
            const unique = new Map();
            users.forEach((user) => {
                const key = user.email?.toLowerCase();
                if (key && !unique.has(key)) {
                    unique.set(key, user);
                }
            });
            return Array.from(unique.values()).sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }));
        })
        .catch((err) => {
            logger.error('ERROR getting report users', err);
            throw err;
        });
};

export const getReportTargets = async () => {
    const url = `${process.env.REACT_APP_API_URL}/reports/target`;
    logger.log('GETTING Report Targets: ', url);

    return fetch(url, {
        headers: reportHeaders(),
        method: 'GET',
    })
        .then((response) => response.json())
        .then((data) => {
            logger.log(data);
            if (!data?.records?.length) return [];
            return data.records.map((item) => ({ ...item }));
        })
        .catch((err) => {
            logger.error('ERROR getting report targets', err);
            throw err;
        });
};

export const getReportConfigs = async () => {
    const url = `${process.env.REACT_APP_API_URL}/reports/config`;
    logger.log('GETTING Report Configs: ', url);

    return fetch(url, {
        headers: reportHeaders(),
        method: 'GET',
    })
        .then((response) => response.json())
        .then((data) => {
            logger.log(data);
            if (!data?.records?.length) return [];
            return data.records.map(mapReportConfig);
        })
        .catch((err) => {
            logger.error('ERROR getting report configs', err);
            throw err;
        });
};

export const createReportConfig = async (config) => {
    const url = `${process.env.REACT_APP_API_URL}/reports/config`;
    const payload = { ...config };
    delete payload.id;
    delete payload.recipients;

    logger.log('CREATING Report Config: ', url, payload);

    return fetch(url, {
        headers: reportHeaders(),
        method: 'POST',
        body: JSON.stringify(payload),
    })
        .then((response) => response.json())
        .then((data) => {
            logger.log(data);
            return parseReportConfigResponse(data, config);
        })
        .catch((err) => {
            logger.error('ERROR creating report config', err);
            throw err;
        });
};

export const updateReportConfig = async (config) => {
    const url = `${process.env.REACT_APP_API_URL}/reports/config`;
    
    const payload = { ...config };
    delete payload.id;
    delete payload.recipients;

    logger.log('UPDATING Report Config: ', url, payload);

    return fetch(url, {
        headers: reportHeaders(),
        method: 'PUT',
        body: JSON.stringify(payload),
    })
        .then((response) => response.json())
        .then((data) => {
            logger.log(data);
            return parseReportConfigResponse(data, config);
        })
        .catch((err) => {
            logger.error('ERROR updating report config', err);
            throw err;
        });
};
